import KeychainManager from './KeychainManager'

export const keychainManager = new KeychainManager()
Object.freeze(keychainManager)

export const isInitialized = (): boolean => {
  return keychainManager.state.isInitiazed
}

export const hasVault = async () => {
  const keychainState = keychainManager.state.keychains.length > 0 || keychainManager.state.vault
  if (keychainState) return true
  return keychainManager.hasVaultInStorage()
}

export const isVaultUnlocked = (): boolean => {
  return keychainManager.state.isUnlocked
}

export const isPasswordSet = async () => {
  const result = await keychainManager.verifyPassword('')

  return !result
}
